(function ($) {
	var confirmModal = $(".js-account-modal");
	var confirmModalHeading = confirmModal.find(".js-account-modal-heading");
	var confirmModalBody = confirmModal.find(".js-account-modal-body");
	var okBtn = confirmModal.find(".js-account-modal-confirm");
	var cancelBtn = confirmModal.find(".js-account-modal-decline");

	const activateTab = (tab) => {
		if (!tab) {
			tab = "manage-gifts";
		}
		let $tab = $('input[name="account-tab"][id="' + tab + '"]');
		if ($tab.length) {
			$tab.prop("checked", true);
			$(".js-tab-content").removeClass("active");
			$('.js-tab-content[data-id="' + tab + '-content"]').addClass(
				"active",
			);
		}
	};

	const initialTab = new URLSearchParams(window.location.search).get("tab");
	activateTab(initialTab);
	history.replaceState({ tab: initialTab }, "", window.location.href);

	// Handle tab switching
	$(document).on("change", 'input[name="account-tab"]', function () {
		var tabId = $(this).val();
		$(".js-tab-content").removeClass("active");
		$('.js-tab-content[data-id="' + tabId + '-content"]').addClass(
			"active",
		);
		history.pushState({ tab: tabId }, "", "?tab=" + tabId);
	});

	$(window).on("popstate", function (e) {
		const state = e.originalEvent.state;
		const tab = state?.tab;
		activateTab(tab);
	});

	var $notice = $(".js-account-notice");
	var $save = $(".js-gift-save-btn");
	var isDirty = false;

	// Handle quantity changes for desktop inputs
	$(document).on("input", ".product-quantity", function () {
		var $input = $(this);
		var quantity = parseInt($input.val());
		var defaultQuantity = parseInt($input.data("value"));
		var $product = $input.closest(".js-product");
		var $inputMobile = $product.find(".product-quantity-mobile");

		$inputMobile.val(quantity);
		if (quantity !== defaultQuantity) {
			$notice.addClass("active");
			$save.prop("disabled", false);
			isDirty = true;
		} else {
			$notice.removeClass("active");
			$save.prop("disabled", true);
			isDirty = false;
		}
	});

	// Handle quantity changes for mobile inputs
	$(document).on("input", ".product-quantity-mobile", function () {
		var $input = $(this);
		var quantity = parseInt($input.val());
		var defaultQuantity = parseInt($input.data("value"));
		var $product = $input.closest(".js-product");
		var $inputDesktop = $product.find(".product-quantity");

		$inputDesktop.val(quantity);
		if (quantity !== defaultQuantity) {
			$notice.addClass("active");
			$save.prop("disabled", false);
			isDirty = true;
		} else {
			$notice.removeClass("active");
			$save.prop("disabled", true);
			isDirty = false;
		}
	});

	// Intercept internal link clicks
	$(document).on("click", "a:not(.js-delete-product)", function (e) {
		if (isDirty) {
			e.preventDefault(); // Stop the navigation

			const href = $(this).attr("href");

			confirmModal.addClass("active");
			confirmModalHeading.html("Leave without saving");
			confirmModalBody.html(
				"Are you sure you want to leave this page without saving?",
			);
			okBtn.html("Yes, leave");
			cancelBtn.html("No, stay");

			okBtn.off("click").on("click", function () {
				confirmModal.removeClass("active").removeClass("saving");
				isDirty = false; // Reset dirty state
				window.location.href = href; // Continue to new page
			});

			cancelBtn.off("click").on("click", function () {
				confirmModal.removeClass("active").removeClass("saving"); // Stay on page
			});
		}
	});

	// Show warning when leaving the page
	$(window).on("beforeunload", function (e) {
		if (isDirty) {
			e.preventDefault();
			e.returnValue = "";
		}
	});

	// Save details when clicking the save button
	$(document).on("click", ".js-gift-save-btn", function (e) {
		e.preventDefault();
		var $products = $(".js-product");
		var batchData = [];

		$products.each(function () {
			var $product = $(this);
			var productId = $product.data("id");
			var quantity = $product.find(".product-quantity").val();

			batchData.push({
				product: productId,
				quantity: quantity,
			});
		});

		confirmModal.addClass("active");
		confirmModalHeading.html("Save all changes?");
		confirmModalBody.html("");
		okBtn.html("Yes");
		cancelBtn.html("No");

		okBtn.off("click").on("click", function () {
			confirmModal.addClass("saving");
			okBtn.html("Saving");
			okBtn.prop("disabled", true);

			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: {
					action: "batch_update",
					batches: batchData,
				},
				success: function (response) {
					if (response.success) {
						// Update the UI with the new quantities
						response.data.forEach(function (item) {
							var $product = $(
								".js-product[data-id='" + item.product + "']",
							);
							$product
								.find(".product-quantity")
								.data("value", item.stock)
								.val(item.stock);
							$product
								.find(".product-quantity-mobile")
								.data("value", item.stock)
								.val(item.stock);
							$product
								.find(".product-req-col .product-req")
								.text(item.needed);
							$product
								.find(".product-req--mobile")
								.text(item.needed);
						});
					} else {
						console.error("Failed to batch update:", response);
					}
				},
				error: function (xhr, status, error) {
					console.error("AJAX error:", error);
				},
				complete: function () {
					// Remove adding class after completion
					confirmModal.removeClass("active").removeClass("saving");
					$notice.removeClass("active");
					$save.prop("disabled", true);
					okBtn.prop("disabled", false);
					isDirty = false; // Reset dirty state
				},
			});
		});

		cancelBtn.off("click").on("click", function () {
			confirmModal.removeClass("active").removeClass("saving");
		});
	});

	// Handle product deletion
	$(document).on("click", ".js-delete-product", function (e) {
		e.preventDefault();
		var removeBtn = $(this);
		var productId = $(this).data("product-id");

		confirmModal.addClass("active");
		confirmModalHeading.html("Deleting gift");
		confirmModalBody.html("Are you sure you want to delete this gift?");
		okBtn.html("Yes");
		cancelBtn.html("No");

		okBtn.off("click").on("click", function () {
			confirmModal.addClass("saving");
			okBtn.html("Deleting");
			okBtn.prop("disabled", true);

			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: {
					action: "delete_product_from_registry",
					product_id: productId,
				},
				success: function success(response) {
					if (response.success) {
						removeBtn.closest("tr").remove();
					} else {
						console.error(
							"Failed to remove product:",
							response.data,
						);
					}
				},
				error: function error(xhr, status, _error3) {
					console.error("AJAX error:", _error3);
				},
				complete: function () {
					confirmModal.removeClass("active").removeClass("saving");
					okBtn.prop("disabled", false);
				},
			});
		});
		cancelBtn.off("click").on("click", function () {
			confirmModal.removeClass("active").removeClass("saving");
		});
	});

	// var $detailsNotice = $('.js-details-notice');
	var $detailsSave = $(".js-wedding-save-btn");
	var isDetailsDirty = false;
	var deletedPlacePhotos = [];
	var deletedCouplePhotos = [];
	var toBeUploadedPlaceFiles = [];
	var toBeUploadedCoupleFiles = [];

	// Utility to format file size (decimal MB/KB, not binary)
	const formatFileSize = function (bytes) {
		if (bytes >= 1000000) {
			return (bytes / 1000000).toFixed(2) + "MB";
		} else if (bytes >= 1000) {
			return (bytes / 1000).toFixed(2) + "KB";
		} else {
			return bytes + "B";
		}
	};

	// Basic HTML escape
	const escapeHtml = function (text) {
		return $("<div>").text(text).html();
	};

	// Display files to be uploaded
	$(".js-upload-component").each(function () {
		var $this = $(this);
		var identity = $this.data("id");
		// var $dropArea = $this.find('.js-upload-area');
		var $fileInput = $this.find(".js-upload-input");
		var $newUpload = $this.find(".js-new-upload");

		// // Drag over
		// $dropArea.on('dragover', function (e) {
		//   e.preventDefault();
		//   e.stopPropagation();
		//   $dropArea.addClass('hover');
		// });

		// // Drag leave
		// $dropArea.on('dragleave', function (e) {
		//   e.preventDefault();
		//   e.stopPropagation();
		//   $dropArea.removeClass('hover');
		// });

		// // Drop
		// $dropArea.on('drop', function (e) {
		//   e.preventDefault();
		//   e.stopPropagation();
		//   $dropArea.removeClass('hover');

		//   var files = e.originalEvent.dataTransfer.files;
		//   handleFiles(files);
		// });

		// File selected via input
		$fileInput.on("change", function () {
			const newFiles = Array.from(this.files);
			var sumFiles = [];
			var items = "";

			// Merge new files into fileList (you can customize how duplicates are handled)
			if (identity === "place-setting") {
				toBeUploadedPlaceFiles = newFiles;
				// toBeUploadedPlaceFiles = toBeUploadedPlaceFiles.concat(newFiles);
				sumFiles = toBeUploadedPlaceFiles;
				// console.log('toBePlace', toBeUploadedPlaceFiles);
			} else if (identity === "couple-photo") {
				toBeUploadedCoupleFiles = newFiles;
				// toBeUploadedCoupleFiles = toBeUploadedCoupleFiles.concat(newFiles);
				sumFiles = toBeUploadedCoupleFiles;
				// console.log('toBeCouple', toBeUploadedCoupleFiles);
			}

			sumFiles.forEach((file) => {
				const url = URL.createObjectURL(file);
				const name = file.name;
				const size = formatFileSize(file.size);
				const nameWithoutExt = name.substring(0, name.lastIndexOf("."));

				const html = `
          <div class="upload-item js-new-item">
            <img src="${url}" alt="${nameWithoutExt}">
            <div class="upload-item__details">
              <span class="upload-item__name">${escapeHtml(name)}</span>
              <span class="upload-item__size">${size}</span>
            </div>
            <span class="upload-item__remove js-remove-new-upload" data-size="${file.size}" data-name="${name}"></span>
          </div>
        `;

				items += html;
			});

			$newUpload.html(items);

			// $notice.addClass('active');
			$detailsSave.prop("disabled", false);
			isDetailsDirty = true;
		});
	});

	$(document).on("click", ".js-remove-upload", function (e) {
		e.preventDefault();

		var $delete = $(this);
		var id = parseInt($delete.data("id"));
		var $item = $delete.closest(".js-uploaded-item");
		var $wrapper = $item.closest(".js-upload-component");
		var identity = $wrapper.data("id");

		// Remove the ID from the respective lists
		if (identity === "place-setting") {
			deletedPlacePhotos.push(id);
			// console.log('place', deletedPlacePhotos);
		} else if (identity === "couple-photo") {
			deletedCouplePhotos.push(id);
			// console.log('couple', deletedCouplePhotos);
		}

		// Optionally remove the preview item from DOM
		$item.remove();

		// $notice.addClass('active');
		$detailsSave.prop("disabled", false);
		isDetailsDirty = true;
	});

	$(document).on("click", ".js-remove-new-upload", function (e) {
		e.preventDefault();

		var $delete = $(this);
		var name = $delete.data("name");
		var size = $delete.data("size");
		var $item = $delete.closest(".js-new-item");
		var $wrapper = $item.closest(".js-upload-component");
		var identity = $wrapper.data("id");

		// Remove the ID from the respective lists
		if (identity === "place-setting") {
			toBeUploadedPlaceFiles = toBeUploadedPlaceFiles.filter(
				(file) => !(file.name === name && file.size === size),
			);
			// console.log('toBePlace', toBeUploadedPlaceFiles);
		} else if (identity === "couple-photo") {
			toBeUploadedCoupleFiles = toBeUploadedCoupleFiles.filter(
				(file) => !(file.name === name && file.size === size),
			);
			// console.log('toBeCouple', toBeUploadedCoupleFiles);
		}

		// Optionally remove the preview item from DOM
		$item.remove();

		// $notice.addClass('active');
		$detailsSave.prop("disabled", false);
		isDetailsDirty = true;
	});

	// Handle input changes in the wedding event details form
	$(document).on("input", "#wedding-event-details-form input", function () {
		var $input = $(this);
		var value = $input.val();
		var defaultValue = $input.data("value");

		if (value !== defaultValue) {
			// $detailsNotice.addClass('active');
			$detailsSave.prop("disabled", false);
			isDetailsDirty = true;
		} else {
			// $detailsNotice.removeClass('active');
			$detailsSave.prop("disabled", true);
			isDetailsDirty = false;
		}
	});

	// Intercept internal link clicks
	$(document).on("click", "a:not(.js-delete-product)", function (e) {
		if (isDetailsDirty) {
			e.preventDefault(); // Stop the navigation

			const href = $(this).attr("href");

			confirmModal.addClass("active");
			confirmModalHeading.html("Leave without saving");
			confirmModalBody.html(
				"Are you sure you want to leave this page without saving?",
			);
			okBtn.html("Yes, leave");
			cancelBtn.html("No, stay");

			okBtn.off("click").on("click", function () {
				confirmModal.removeClass("active").removeClass("saving");
				isDetailsDirty = false; // Reset dirty state
				window.location.href = href; // Continue to new page
			});

			cancelBtn.off("click").on("click", function () {
				confirmModal.removeClass("active").removeClass("saving"); // Stay on page
			});
		}
	});

	// Show warning when leaving the page
	$(window).on("beforeunload", function (e) {
		if (isDetailsDirty) {
			e.preventDefault();
			e.returnValue = "";
		}
	});

	const repopulateForm = function (data) {
		$('#wedding-event-details-form input[type="text"]').each(function () {
			var $input = $(this);
			var name = $input.attr("name");

			if (name in data) {
				$input.val(data[name]);
				$input.data("value", data[name]); // Update default value
			}
		});

		if ("place_setting_photos" in data && data.place_setting_photos) {
			var $currentUpload = $(
				'.js-upload-component[data-id="place-setting"] .js-current-upload',
			);
			var $newUpload = $(
				'.js-upload-component[data-id="place-setting"] .js-new-upload',
			);
			var $items = "";

			data.place_setting_photos.forEach(function (photo) {
				var url = photo.sizes.thumbnail || photo.url;
				var name = photo.filename || photo.name;
				var alt = photo.alt || photo.name;
				var size = formatFileSize(photo.filesize || 0);
				var id = photo.id;

				const html = `
          <div class="upload-item js-uploaded-item">
            <img src="${url}" alt="${alt}">
            <div class="upload-item__details">
              <span class="upload-item__name">${escapeHtml(name)}</span>
              <span class="upload-item__size">${size}</span>
            </div>
            <span class="upload-item__remove js-remove-upload" data-id="${id}"></span>
          </div>
        `;

				$items += html;
			});

			$currentUpload.html($items);
			$newUpload.empty();
			toBeUploadedPlaceFiles = [];
			deletedPlacePhotos = [];
		}

		if ("couple_photos" in data && data.couple_photos) {
			var $currentUpload = $(
				'.js-upload-component[data-id="couple-photo"] .js-current-upload',
			);
			var $newUpload = $(
				'.js-upload-component[data-id="couple-photo"] .js-new-upload',
			);
			var $items = "";

			data.couple_photos.forEach(function (photo) {
				var url = photo.sizes.thumbnail || photo.url;
				var name = photo.filename || photo.name;
				var alt = photo.alt || photo.name;
				var size = formatFileSize(photo.filesize || 0);
				var id = photo.id;

				const html = `
          <div class="upload-item js-uploaded-item">
            <img src="${url}" alt="${alt}">
            <div class="upload-item__details">
              <span class="upload-item__name">${escapeHtml(name)}</span>
              <span class="upload-item__size">${size}</span>
            </div>
            <span class="upload-item__remove js-remove-upload" data-id="${id}"></span>
          </div>
        `;

				$items += html;
			});

			$currentUpload.html($items);
			$newUpload.empty();
			toBeUploadedCoupleFiles = [];
			deletedCouplePhotos = [];
		}
	};

	// Save wedding event details
	$(document).on("submit", "#wedding-event-details-form", function (e) {
		e.preventDefault();
		var formData = new FormData(this);

		toBeUploadedPlaceFiles.forEach((file, i) => {
			formData.append(`place_setting_photos[]`, file);
		});
		toBeUploadedCoupleFiles.forEach((file, i) => {
			formData.append(`couple_photos[]`, file);
		});
		deletedPlacePhotos.forEach((id, i) => {
			formData.append(`deleted_place_setting_photos[]`, id);
		});
		deletedCouplePhotos.forEach((id, i) => {
			formData.append(`deleted_couple_photos[]`, id);
		});
		formData.append("action", "save_wedding_event_details");

		confirmModal.addClass("active");
		confirmModalHeading.html("Save all changes?");
		confirmModalBody.html("");
		okBtn.html("Yes");
		cancelBtn.html("No");

		okBtn.off("click").on("click", function () {
			confirmModal.addClass("saving");
			okBtn.html("Saving");
			okBtn.prop("disabled", true);

			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: formData,
				contentType: false,
				processData: false,
				success: function (response) {
					// console.log(response);
					if (response.success) {
						// $detailsNotice.addClass('active').text('Details saved successfully!');
						// setTimeout(function () {
						//   $detailsNotice.removeClass('active');
						// }, 3000);
						repopulateForm(response.data);
					} else {
						console.error("Error saving details:", response.data);
					}
				},
				error: function (xhr, status, error) {
					console.error("AJAX error:", error);
				},
				complete: function () {
					// Remove adding class after completion
					confirmModal.removeClass("active").removeClass("saving");
					// $detailsNotice.removeClass('active');
					$detailsSave.prop("disabled", true);
					okBtn.prop("disabled", false);
					isDetailsDirty = false; // Reset dirty state
				},
			});
		});

		cancelBtn.off("click").on("click", function () {
			confirmModal.removeClass("active").removeClass("saving");
		});
	});
})(jQuery);
